import { useEffect, useId, useRef, useState } from 'react';

export default function InfoHint({ text }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const hintId = useId();

  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const handlePointerDown = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    };

    const frameId = requestAnimationFrame(() => {
      document.addEventListener('pointerdown', handlePointerDown);
      document.addEventListener('keydown', handleKeyDown);
    });

    return () => {
      cancelAnimationFrame(frameId);
      document.removeEventListener('pointerdown', handlePointerDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open]);

  return (
    <span ref={rootRef} className="relative inline-flex shrink-0 align-middle">
      <button
        type="button"
        aria-label="Пояснение"
        aria-expanded={open}
        aria-controls={hintId}
        onPointerDown={(event) => event.stopPropagation()}
        onClick={(event) => {
          event.stopPropagation();
          setOpen((current) => !current);
        }}
        className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-300 text-[10px] font-semibold leading-none text-slate-500 transition hover:border-slate-400 hover:text-slate-900 dark:border-slate-600 dark:text-slate-400 dark:hover:text-slate-200 sm:h-4 sm:w-4"
      >
        i
      </button>
      {open && (
        <span
          id={hintId}
          role="tooltip"
          className="absolute top-[calc(100%+6px)] left-0 z-50 w-56 rounded-lg border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 px-2.5 py-2 text-xs font-normal normal-case tracking-normal text-slate-800 dark:text-slate-200 shadow-lg shadow-slate-300/50 dark:shadow-slate-950/40"
        >
          {text}
        </span>
      )}
    </span>
  );
}
